import type {
  GraphQLClientGlobalOptions,
  GraphQLClientOptions,
  TypedDocumentNode,
  Variables,
} from './types';
import { base } from './base';

const globalOptions: Omit<GraphQLClientGlobalOptions, 'endpointUrl'> = {
  headers: {},
  onError: (error: unknown) => {
    throw error;
  },
};

export const graphQLClient = async <T, V extends Variables = Variables>(
  document: TypedDocumentNode<T, V>,
  variables: V,
  options: GraphQLClientOptions = {}
): Promise<T> => {
  const requestHeaders =
    options.requestHeaders instanceof Headers
      ? options.requestHeaders
      : new Headers(options.requestHeaders);

  Object.entries(globalOptions.headers).forEach(([key, value]) => {
    if (!requestHeaders.has(key)) {
      requestHeaders.set(key, value);
    }
  });

  const mergedOptions = {
    ...options,
    requestHeaders,
  };

  try {
    if (globalOptions.wrapper) {
      return globalOptions.wrapper(base<T, V>(document, variables, mergedOptions));
    }
    return base<T, V>(document, variables, mergedOptions);
  } catch (error) {
    globalOptions.onError(error);
  }
};

graphQLClient.init = (options: GraphQLClientGlobalOptions): void => {
  Object.defineProperties(globalOptions, Object.getOwnPropertyDescriptors(options));
  base.init(options.endpointUrl);
};
